import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import messages from './messages';
import styles from './styles.css';

const limitLength = (value, limit) => (value && value.slice(0, limit));

const UpdateWireDescriptionsForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.editWireDescriptions} />}
    submitLabel={<FormattedMessage {...messages.updateWire} />}
  >
    <ControlLabel className={styles.controlLabel} htmlFor="updatedWireDescription1">
      <FormattedMessage {...messages.description} values={{ index: '1' }} /> <span className={styles.fontReg}><FormattedMessage {...messages.max} values={{ index: '4' }} /> </span>
      <Field
        required
        name="updatedWireDescription1"
        component="input"
        type="text"
        className="form-control"
        normalize={(value) => limitLength(value, 30)}
      />
    </ControlLabel>
    <ControlLabel className={styles.controlLabel} htmlFor="updatedWireDescription2">
      <FormattedMessage {...messages.description} values={{ index: '2' }} /> <span className={styles.fontReg}><FormattedMessage {...messages.max} values={{ index: '5' }} /> </span>
      <Field
        required
        name="updatedWireDescription2"
        component="input"
        type="text"
        className="form-control"
        normalize={(value) => limitLength(value, 30)}
      />
    </ControlLabel>
    <ControlLabel className={styles.controlLabel} htmlFor="updatedWireDescription3">
      <FormattedMessage {...messages.description} values={{ index: '3' }} /> <span className={styles.fontReg}><FormattedMessage {...messages.max} values={{ index: '6' }} /> </span>
      <Field
        required
        name="updatedWireDescription3"
        component="input"
        type="text"
        className="form-control"
        normalize={(value) => limitLength(value, 30)}
      />
    </ControlLabel>
  </ModalForm>
);


UpdateWireDescriptionsForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'UpdateWireDescriptions', enableReinitialize: true })(UpdateWireDescriptionsForm);



// WEBPACK FOOTER //
// ./src/components/UpdateWireDescriptionsForm/index.js